<div>
    <div id="container" [attr.width]="graphData.width" [attr.height]="graphData.height"></div>
</div>